import Vue from 'vue'
import Router from 'vue-router'

// 1. 必须使用插件
Vue.use(Router)

// 2. 配置页面路径
const routes = [
  {
    path: '/login',
    name: 'Login',
    // 懒加载写法：只有访问时才加载登录页代码
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    // Layout 是外壳，里面包含侧滑菜单
    component: () => import('../views/Layout.vue'),
    redirect: '/weight', // 默认进体重页面
    children: [
      {
        path: 'weight',
        name: 'Weight',
        component: () => import('../views/weight/Weight.vue')
      },
      {
        path: 'recipe',
        name: 'Recipe',
        component: () => import('../views/recipe/Recipe.vue'),
        meta: { keepAlive: true }
      },
      {
        path: 'recipe_create',
        name: 'RecipeCreate',
        component: () => import('../views/recipe/RecipeCreate.vue')
      },
      {
        path: 'recipe_detail/:id',
        name: 'RecipeDetail',
        component: () => import('../views/recipe/RecipeDetail.vue')
      },
      {
        path: 'recipe_edit/:id',
        name: 'RecipeEdit',
        component: () => import('../views/recipe/RecipeEdit.vue')
      },
      {
        path: 'diary',
        name: 'Diary',
        component: () => import('../views/diary/Diary.vue'),
        meta: { keepAlive: true }
      },
      {
        path: 'diary_create',
        name: 'DiaryCreate',
        component: () => import('../views/diary/DiaryCreate.vue')
      },
      {
        path: 'diary_detail/:id',
        name: 'DiaryDetail',
        component: () => import('../views/diary/DiaryDetail.vue')
      },
      {
        path: 'diary_edit/:id',
        name: 'DiaryEdit',
        component: () => import('../views/diary/DiaryEdit.vue')
      },
      {
        path: 'ledger',
        name: 'Ledger',
        component: () => import('../views/ledger/Ledger.vue'),
        meta: { keepAlive: true }
      },
      {
        path: 'ledger_create',
        name: 'LedgerCreate',
        component: () => import('../views/ledger/LedgerCreate.vue')
      },
      {
        path: 'ledger_edit/:id',
        name: 'LedgerEdit',
        component: () => import('../views/ledger/LedgerEdit.vue')
      },
      {
        path: 'memo',
        name: 'Memo',
        component: () => import('../views/memo/Memo.vue'),
        meta: { keepAlive: true }
      },
      {
        path: 'memo_create',
        name: 'MemoCreate',
        component: () => import('../views/memo/MemoCreate.vue')
      },
      {
        path: 'memo_edit',
        name: 'MemoEdit',
        component: () => import('../views/memo/MemoEdit.vue')
      },
      {
        path: 'note',
        name: 'Note',
        component: () => import('../views/note/Note.vue'),
        meta: { keepAlive: true }
      },
      {
        path: 'note_create',
        name: 'NoteCreate',
        component: () => import('../views/note/NoteCreate.vue')
      },
      {
        path: 'memo_edit',
        name: 'NoteEdit',
        component: () => import('../views/note/NoteEdit.vue')
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('../views/user/User.vue')
      }
    ]
  }
]

// 3. 实例化路由
const router = new Router({
  mode: 'hash', // 安卓 APP 必须用 hash 模式，否则打包后会白屏
  routes: routes // 这里就是你刚才报错的地方，必须把上面定义的 routes 放进来
})

// 4. 路由守卫：登录检查逻辑
router.beforeEach((to, from, next) => {
  // 从本地存储读取 token
  const token = localStorage.getItem('user_token')
  
  if (to.path !== '/login' && !token) {
    // 如果不是去登录页，且没登录，强行踢回登录页
    next('/login')
  } else if (to.path === '/login' && token) {
    // 如果已经登录了还想去登录页，直接送去主页
    next('/weight')
  } else {
    // 否则放行
    next()
  }
})

// 5. 导出，供 main.js 使用
export default router